import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import './styles.scss';

export default function FullSizeTab({ bodyClassName, children, className }) {
  useEffect(() => {
    const bodyClassNames = ['has-full-size-tab', bodyClassName].filter(name => name);

    for (const className of bodyClassNames) {
      document.body.classList.add(className);
    }

    return () => {
      for (const className of bodyClassNames) {
        document.body.classList.remove(className);
      }
    };
  }, []);

  return (
    <div className={classNames('full-size-tab', className)}>
      {children}
    </div>
  );
}

FullSizeTab.propTypes = {
  bodyClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
